module.exports = __webpack_public_path__ + "img/skype.01a41590.svg";